export const UserType = {
    PROMOTER: 'PROMOTER',
    ENTITY: 'ENTITY',
    IEFP: 'IEFP',

    values: () => {
        return ['PROMOTER', 'ENTITY', 'IEFP'];
    }
}